// Docs can be seen at https://github.com/verlok/vanilla-lazyload
let lazyLoadInstance;

export const initLazyLoad = () => {
  lazyLoadInstance = new LazyLoad({
    threshold : 1750,
    callback_loaded: (el) => {
      const parent = el.closest('.media-block-lazy-wrap');
      if(parent){
        parent.classList.add('loaded');
      }
    }
  });
}

export const updateLazyLoad = () => {
  lazyLoadInstance.update();
}

export const loadAllAssets = () => {
  lazyLoadInstance.loadAll();
}